import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { TalkdeskFormItemKeys } from "../constants";

const REQUIRED_NAME_RULE = generateFormItemRequiredRules("Talkdesk selection");
const REQUIRED_ID_RULE = generateFormItemRequiredRules("Campaign Id");

const NAME_LABEL = "Campaign Name";
const ID_LABEL = "Talkdesk Campaign";
const ID_PLACEHOLDER = "Talkdesk Campaign Id";

export function TalkdeskFormItems(): JSX.Element {
    return (
        <>
            <RVFormFloatingLabelWrap
                showFormLabel
                name={TalkdeskFormItemKeys.talkdeskName}
                label={NAME_LABEL}
                rules={REQUIRED_NAME_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                name={TalkdeskFormItemKeys.talkdeskID}
                label={ID_LABEL}
                placeholder={ID_PLACEHOLDER}
                showFormLabel
                rules={REQUIRED_ID_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
        </>
    );
}
